<template>
  <div class="export-of-services">
    <div class="banner">
      <img src="../../../assets/img/businessScope/exportOfServices/banner.jpg" />
      <div class="banner-text">
        <div class="container wow slideInLeft">
          <h1>{{$t("exportOfServices.banner.bannerTitle")}}</h1>
          <p>{{$t("exportOfServices.banner.bannerP")}}</p>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="headline">
        <h1>{{$t("exportOfServices.headlineTitle")}}</h1>
        <p>{{$t("exportOfServices.headlineP")}}</p>
      </div>
      <p class="paragraph">{{$t("exportOfServices.des1")}}</p>
    </div>

    <div class="enterprise-advantage">
      <div class="container">
        <div class="box">
          <el-row :gutter="60">
            <el-col :span="8" :xs="24" class="pic" >
              <img src="../../../assets/img/businessScope/exportOfServices/advantage_icon.png" />
            </el-col>
            <el-col :span="16" :xs="24" >
              <div class="des">
                <p>{{$t('exportOfServices.enterpriseAdvantage.titleEn')}}</p>
                <h2>{{$t('exportOfServices.enterpriseAdvantage.title')}}</h2>
                <p>{{$t('exportOfServices.enterpriseAdvantage.des')}}</p>
                <p class="tr">____</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="container">
      <p class="paragraph">{{$t("exportOfServices.des2")}}</p>
      <div class="num-box">
        <el-row :gutter="30">
          <el-col :span="8"  :xs="24" v-for="(item,index) in $t('exportOfServices.lists')" :key="index">
            <div class="des-box">
              <h2>{{item.title}}</h2>
              <p>{{item.des}}</p>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-row :gutter="30" class="pic-row">
        <el-col :span="12" :xs="24" >
          <img src="../../../assets/img/businessScope/exportOfServices/part1.png" />
        </el-col>
        <el-col :span="12" :xs="24" >
          <img src="../../../assets/img/businessScope/exportOfServices/part2.png" />
        </el-col>
      </el-row>
      
    </div>

  </div>
</template>

<script>
export default {
  name: "ExportOfServices",
  data() {
    return {

    };
  },
  mounted() {  
    var options = { live: false };
    new this.$wow.WOW(options).init();
  },
  methods: {

  }
};
</script>

<style scoped lang="scss">
.export-of-services {
  
  .paragraph{
    width:70%;
    margin:0 auto;
    margin-bottom:60px;
    text-align: justify;
  }
   
  .enterprise-advantage{
    background:url(../../../assets/img/businessScope/exportOfServices/advantage.jpg) no-repeat left/cover;
    background-size: 50% ;
    padding:100px 0;
    margin-bottom: 100px;
    .box{
      background: #0054A7;
      color:#fff;
      .pic{
        text-align: center;
        padding-top:80px;
      }
      .des{
        padding:40px 70px 30px 0;
        h2{
          font-weight: bold;
          margin-bottom:20px;
        }
        .tr{
          text-align: right;
        }
      }
    }
  
    

  }

  .num-box{
    margin-bottom:100px;
    .des-box{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background:#F5F5F5;
      height:240px;
      font-weight: bold;
      padding:20px;
      h2{
        font-size: 50px;
      }
      &:hover{
        background:#0054A7 ;
        color:#fff;
      }
    }
  }

  @media screen and (max-width:768px){
    .paragraph{
      width:100%;
      margin:0 auto;
      margin-bottom:40px;
    }
    
    .enterprise-advantage{
      background:none;
      padding:4px 0;
      margin-bottom: 40px;
      .box{
        background: #0054A7;
        color:#fff;
        .pic{
          text-align: center;
          padding-top:20px;
          img{
            width:50px;
          }
        }
        .des{
          padding:20px;
          h2{
            font-weight: bold;
            margin-bottom:20px;
          }
          .tr{
            text-align: right;
          }
        }
      }

    }

    .num-box{
      margin-bottom:40px;
      .des-box{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background:#F5F5F5;
        height:auto;
        font-weight: bold;
        padding:20px;
        margin-bottom:20px;
        h2{
          font-size: 50px;
        }
        &:hover{
          background:#0054A7 ;
          color:#fff;
        }
      }
    }
    .pic-row img{
      margin-bottom:20px;
    }
  }
}
</style>
